import type { AnimationTypes } from '../../animations/animations.types'
import type { AnimationConfig } from '../../Animate.types'
import { animations } from '../../animations/animations'

const getDuration = (animationCfg: AnimationConfig, animationName: AnimationTypes): number => {
  return animationCfg.duration || animations[animationName].config.duration
}

export default getDuration
